import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { SubscriptionPackage } from '../../components'
import { getAppSettings } from '../../redux/actions/settings'
import styles from './PackagePayment.module.css'

const PackagePayment = ({
  packages,
  paymentGateway
}) => {
  const dispatch = useDispatch()
  const telcoPackageKey = 'telco.package.url'

  useEffect(() => {
    dispatch(getAppSettings([telcoPackageKey]))
  }, [dispatch])

  const renderPackageList = (packages) => {
    // const danaPacks = packages
    //   .filter(item => {
    //     return Object.keys(item.payments)
    //       .some((key) => key.startsWith('dana'));
    //   })

    const telcoPacks = packages
      .filter(item => {
        return Object.entries(item.payments)
          .some(([key, value]) => key.startsWith('telco') && value.description);
      })

    // if (danaPacks.length <= 0 && telcoPacks.length <= 0) {
    //   return <p className={styles['title']}>This content is not available for your operator</p>
    // }

    const result = []

    // if (danaPacks.length > 0) {
    //   result.push(
    //     <div key='dana'>
    //       <p className={styles['title']}>Choose Your Plan</p>
    //       {renderPaymentOptions(danaPacks, 'dana')}
    //     </div>
    //   )
    // }
    if (telcoPacks.length > 0) {
      result.push(
        <div key='telco'>
          <p className={styles['title']}>Subscribe Via Telco Plan</p>
          {renderPaymentOptions(telcoPacks, 'telco')}
        </div>
      )
    }

    return result
  }

  const renderPaymentOptions = (packages, gateway) => {
    return (
      <>
        <p className={styles.helperText}>
          {!packages.length ? 'Please use Genflix Mobile App for purchase package' : 'Please use Genflix Mobile App for more package'}
        </p>
        <div className={styles['list-plan']}>
          {packages.map(item => {
            if (item.name) item.title = item.name

            return (
              <SubscriptionPackage
                key={item.id}
                {...item}
                gateway={gateway}
                paymentGateway={paymentGateway}
              />
            )
          })}
        </div>
      </>
    )
  }
  return paymentGateway ? renderPaymentOptions(packages) : renderPackageList(packages)
}

export default PackagePayment
